module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-easter-right-ee18b0f9179a1fc82cc74d53be3c075f.svg";